export default __webpack_public_path__ + "bc9af306b6ab1298c68d540ce2c81313.png";